import { gql } from 'graphql-tag';

const GET_USER_DETAILS = gql`
  query get_user_details($userId: bigint!) {
    users(where: { id: { _eq: $userId } }) {
      id
      display_name
      email
      phone
      avatar_url
      default_role
      updated_at
      created_at
      active
      customer_id
      customer {
        id
        name
      }
      driver {
        id
      }
    }
  }
`;

const GET_REGIONS = gql`
  query admin_userDetails_getRegions {
    regions(order_by: { name: asc }) {
      id
      name
    }
  }
`;

const GET_ALLOWED_REGIONS = gql`
  query admin_userDetails_getAllowedRegions($userId: bigint!) {
    usertoregions(where: { user_id: { _eq: $userId } }, order_by: { region_id: desc }) {
      region_id
      region {
        name
      }
    }
  }
`;

const GET_FEATURES = gql`
  query admin_userDetails_getFeatures {
    features(order_by: { name: asc }) {
      id
      name
      description
      label
      category_id
    }
  }
`;

const GET_ALLOWED_FEATURES = gql`
  query admin_userDetails_getAllowedFeatures($userId: bigint!) {
    usertofeatures(where: { user_id: { _eq: $userId } }, order_by: { feature_id: desc }) {
      feature_id
      feature {
        id
        name
        description
        label
        category_id
      }
    }
  }
`;

const GET_CUSTOMERS = gql`
  query get_customer($customerId: bigint!) {
    customers(where: { id: { _eq: $customerId } }) {
      id
      name
      organization {
        customers {
          id
          name
        }
      }
    }
  }
`

// const GET_CUSTOMERS = gql`
// query GetOrganizationAndOtherCustomers($orgId: bigint!) {
//   customer(organization_id: $orgId) {
//     id
//     name
//     organization {
//       id
//       name
//       customers {
//         id
//         name
//       }
//     }
//   }
// }
// `

const GET_ALLOWED_CUSTOMERS = gql`
  query admin_userDetails_getAllowedCustomers($userId: bigint!) {
    usertocustomers(where: { user_id: { _eq: $userId } }, order_by: { customer_id: desc }) {
      customer_id
      customer {
        name
      }
    }
  }
`;

const GET_ALLOWED_PAYER_PAYEES = gql`
  query admin_userDetails_getPayersPayees($customerId: bigint!) {
    payertocustomer(where: { _or: [{ payee_id: { _eq: $customerId } }, { payer_id: { _eq: $customerId } }] }) {
      id
      payee_id
      payer_id
      payer {
        name
      }
      payee {
        name
      }
    }
  }
`;

const GET_ROLETYPES = gql`
  query admin_userDetails_getRoletypes {
    roletypes(order_by: { name: asc }) {
      id
      name
    }
  }
`;

const GET_ALLOWED_ROLES = gql`
  query admin_userDetails_getAllowedRoles($userId: bigint!) {
    usertoroles(where: { user_id: { _eq: $userId } }, order_by: { role_id: desc }) {
      role_id
      roletype {
        name
      }
    }
  }
`;

const UPSERT_ALLOWED_REGIONS = gql`
  mutation admin_userDetails_upsertAllowedRegions($allowedRegionsObj: [usertoregions_insert_input!]!) {
    insert_usertoregions(
      objects: $allowedRegionsObj
      on_conflict: { constraint: usertoregions_user_id_region_id_key, update_columns: [] }
    ) {
      affected_rows
      returning {
        user_id
        region_id
      }
    }
  }
`;

const UPSERT_ALLOWED_ROLES = gql`
  mutation admin_userDetails_upsertAllowedRoles($allowedRolesObj: [usertoroles_insert_input!]!) {
    insert_usertoroles(
      objects: $allowedRolesObj
      on_conflict: { constraint: usertoroles_user_id_role_id_key, update_columns: [] }
    ) {
      affected_rows
      returning {
        user_id
        role_id
      }
    }
  }
`;

const UPSERT_ALLOWED_FEATURES = gql`
  mutation admin_userDetails_upsertAllowedFeatures($allowedFeaturesObj: [usertofeatures_insert_input!]!) {
    insert_usertofeatures(
      objects: $allowedFeaturesObj
      on_conflict: { constraint: usertofeatures_feature_id_user_id_key, update_columns: [] }
    ) {
      affected_rows
      returning {
        user_id
        feature_id
        feature {
          id
          name
          description
          label
          category_id
        }
      }
    }
  }
`;

const UPSERT_ALLOWED_CUSTOMERS = gql`
  mutation admin_userDetails_upsertAllowedCustomers($allowedCustomersObj: [usertocustomers_insert_input!]!) {
    insert_usertocustomers(
      objects: $allowedCustomersObj
      on_conflict: { constraint: usertocustomers_user_id_customer_id_key, update_columns: [] }
    ) {
      affected_rows
      returning {
        user_id
        customer_id
      }
    }
  }
`;

const SAVE_USER_DETAILS = gql`
  mutation save_user_details($userId: bigint!, $userObj: users_set_input!) {
    update_users(where: { id: { _eq: $userId } }, _set: $userObj) {
      affected_rows
      returning {
        id
        users_usertoregions {
          region_id
          region {
            id
            name
            description
          }
        }
        users_usertocustomers {
          customer_id
          customer {
            id
            name
          }
        }
        users_usertofeatures {
          feature_id
          feature {
            id
            name
            label
            description
            category_id
          }
        }
      }
    }
  }
`;

const REFRESH_CLAIMS = gql`
  mutation refresh_user_claims($userId: bigint!) {
    update_users(where: { id: { _eq: $userId } }, _set: { updated_at: "now()" }) {
      affected_rows
      returning {
        id
        updated_at
      }
    }
  }
`;

const TERMINATE_USER = gql`
  mutation admin_userDetails_terminateUser($userId: bigint!) {
    update_users(where: { id: { _eq: $userId } }, _set: { active: false }) {
      affected_rows
      returning {
        id
        active
      }
    }
  }
`;

const REINSTATE_USER = gql`
  mutation admin_userDetails_reinstateUser($userId: bigint!) {
    update_users(where: { id: { _eq: $userId } }, _set: { active: true }) {
      affected_rows
      returning {
        id
        active
      }
    }
  }
`;

const CREATE_USER = gql`
  mutation admin_userEntry_createUser($userObj: users_insert_input!) {
    insert_users(objects: [$userObj]) {
      affected_rows
      returning {
        id
        active
        created_at
      }
    }
  }
`;
const REMOVE_ALLOWED_REGION = gql`
  mutation admin_userDetails_removeAllowedRegion($regionId: bigint!, $userId: bigint!) {
    delete_usertoregions(where: {_and: {region_id: {_eq: $regionId}, user_id: {_eq: $userId}}}) {
      affected_rows
      returning {
        region_id
        user_id
      }
    }
  }
`

const REMOVE_ALLOWED_ROLE = gql`
  mutation admin_userDetails_removeAllowedRole($roleId: bigint!, $userId: bigint!) {
    delete_usertoroles(where: {_and: {role_id: {_eq: $roleId}, user_id: {_eq: $userId}}}) {
      affected_rows
      returning {
        role_id
        user_id
      }
    }
  }
`

const REMOVE_ALLOWED_FEATURE = gql`
  mutation admin_userDetails_removeAllowedFeature($featureId: bigint!, $userId: bigint!) {
    delete_usertofeatures(where: {_and: {feature_id: {_eq: $featureId}, user_id: {_eq: $userId}}}) {
      affected_rows
      returning {
        feature_id
        user_id
        feature {
          id
          name
          description
          label
          category_id
        }
      }
    }
  }
`


const REMOVE_ALLOWED_CUSTOMER = gql`
  mutation admin_userDetails_removeAllowedCustomer($customerId: bigint!, $userId: bigint!) {
    delete_usertocustomers(where: {_and: {customer_id: {_eq: $customerId}, user_id: {_eq: $userId}}}) {
      affected_rows
      returning {
        customer_id
        user_id
      }
    }
  }
`


export {
  GET_USER_DETAILS,
  SAVE_USER_DETAILS,
  GET_REGIONS,
  GET_ALLOWED_REGIONS,
  GET_CUSTOMERS,
  GET_ALLOWED_CUSTOMERS,
  GET_ALLOWED_PAYER_PAYEES,
  GET_ALLOWED_ROLES,
  REFRESH_CLAIMS,
  GET_ROLETYPES,
  TERMINATE_USER,
  REINSTATE_USER,
  UPSERT_ALLOWED_CUSTOMERS,
  UPSERT_ALLOWED_REGIONS,
  UPSERT_ALLOWED_ROLES,
  CREATE_USER,
  REMOVE_ALLOWED_REGION,
  REMOVE_ALLOWED_CUSTOMER,
  REMOVE_ALLOWED_ROLE,
  REMOVE_ALLOWED_FEATURE,
  UPSERT_ALLOWED_FEATURES,
  GET_FEATURES,
  GET_ALLOWED_FEATURES,
};